import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import catalog from './modules/catalog'
import dashboard from './modules/dashboard'
import notification from './modules/notification'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  reducer: (state) => ({
    dashboard: {
      doneOrderItems: state.dashboard.doneOrderItems
    }
  })
})

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    auth,
    catalog,
    dashboard,
    notification
  },
  plugins: [vuexLocal.plugin],
  strict: debug
})
